import { render, staticRenderFns } from "./freeWord.vue?vue&type=template&id=e6195098&scoped=true&"
import script from "./freeWord.vue?vue&type=script&lang=js&"
export * from "./freeWord.vue?vue&type=script&lang=js&"
import style0 from "./freeWord.vue?vue&type=style&index=0&id=e6195098&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6195098",
  null
  
)

export default component.exports